import React from "react"
import SignUp from "./pages/SignUp"
import { AuthProvider } from "./contexts/AuthContext"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Dashboard from "./pages/Dashboard"
import Login from "./pages/Login"
import PrivateRoute from "./components/PrivateRoute.js"
import ForgotPassword from "./pages/ForgotPassword"
import UpdateProfile from "./pages/UpdateProfile"
import Navbar from "./components/Navbar"
import Home from "./pages/Home"
import Profile from "./pages/Profile"
import './css/App.css'
import Favorites from "./pages/Favorites"
import Bets from "./pages/Bets"
import Highscore from "./pages/Highscore"

function App() {
  return (
    <Router>
      <div className="mx-0 px-0"> {/* container will provoke some margins while div not. */}
        <Navbar />
        <AuthProvider>
            <Switch>
              <PrivateRoute exact path="/update-profile" component={UpdateProfile} />
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
              <PrivateRoute exact path="/profile" component={Profile} />
              <PrivateRoute exact path="/favorites" component={Favorites} />
              <PrivateRoute exact path="/bets" component={Bets} />
              <PrivateRoute exact path="/highscore" component={Highscore} />
              <Route exact path="/" component={Home} />
              <Route path="/signup" component={SignUp} />
              <Route path="/login" component={Login} />
              <Route path="/forgot-password" component={ForgotPassword} />
            </Switch>
        </AuthProvider>
      </div>
    </Router>
  )
}

export default App